import './home.css';
import React from 'react';
import Book from './Book';


export default function Home(){


    return (
    <>
     <div className="background-home">
        <div className="header">
          <div className="left-section">
            <img
              className="logo-img"
              src="lilable.png" 
              alt="Logo"
            />
        
          </div>
          <div className="right-section">
            <img src="https://img.icons8.com/ios7/512/search.png" alt="magnify" className='search-btn'/>
          </div>
        </div>
        {/* Scrollable content below */}
        <div className="home-content">
            <h1>Published Lilables:</h1>
            <div className="book-grid">
            <Book />
                    </div>
                    </div>
    </div>
    </>
    )
}